import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ChakraProvider } from "@chakra-ui/react";
import { ErpProvider } from './context/ErpContext.js';     // context sirve para invocar funciones que se van a ejecutar en diferentes lugares desde un solo lugar.
import { ApiDominiosProvider } from './context/apiContextDominios.js';
import { BrowserRouter as Router } from 'react-router-dom';
import PdfPreviewProvider from './components/misc/PdfPreviewProvider.js';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ChakraProvider>
      <Router>
        <ErpProvider>
          <ApiDominiosProvider>
            <PdfPreviewProvider>
              <App />
            </PdfPreviewProvider>
          </ApiDominiosProvider>
        </ErpProvider>
      </Router>
    </ChakraProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
